"use client";

import { useEffect } from "react";

import { useTranslations } from "next-intl";

import { Button } from "@/components/ui/button";
import { reportError } from "@/lib/logger";

/** Errors from (app) pages render inside the sidebar shell, so navigation still works. */
export default function AppError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  const t = useTranslations("errorPage");
  useEffect(() => {
    reportError(error, { digest: error.digest });
  }, [error]);

  return (
    <div role="alert" className="grid flex-1 place-items-center py-16 text-center">
      <div className="flex max-w-sm flex-col items-center gap-3">
        <h1 className="text-lg font-semibold">{t("title")}</h1>
        <p className="text-sm text-muted-foreground">{t("description")}</p>
        {error.digest && (
          <p className="text-xs text-muted-foreground">
            {t("reference", { digest: error.digest })}
          </p>
        )}
        <Button onClick={() => retry()}>{t("retry")}</Button>
      </div>
    </div>
  );
}
